/*
|--------------------------------------------------------------------------
| 常量类，统一维护
|--------------------------------------------------------------------------
|
| 将全局常量配置放置在这里，方便修改
|
*/

export default {
  API_HOST: G_API_HOST,
  LOGIN_URL: '/api/login.htm',
  AUTO_LOGIN_URL: '/api/auto_login.htm',
  LOGOUT_URL: '/api/logout.htm',
  AUTH_TOKEN_KEY:'af885c03a23d4c08827b0c32151a0347',
  AUTH_USER_KEY:'session_user',


  //微信注册登录
  API_LOGIN: '/static/weixin/login.html',

  //会员卡接口
      //会员卡交易记录查询(历史消费充值记录)
      API_CARD_DETAIL_LIST:'/mapi/card_member/card_detail_list.htm',
      //会员卡二维码查询接口(通过二维码查询会员信息)
      API_VIEW_QRCODE_CARD:'/uapi/card/view_qrcode_card.htm',


  //获取验证码
  API_BIND_CARD_PRO:  '/mapi/card_member/bind_card_pro.htm',
  //会员卡绑定
  API_BIND_CARD_FIN:  '/mapi/card_member/bind_card_fin.htm',
  //绑定成功返回会员卡信息
  API_VIEW_CARD:   '/mapi/card_member/view_card.htm',
  //会员卡解绑
  API_UNBIND_CARD:'/mapi/card_member/unbind_card.htm',
  //会员卡找回第一步，发送验证码
  API_FIND_BACK_PRO:'/mapi/card_member/find_back_pro.htm',
  //会员卡找回第二步，找回会员卡
  API_FIND_BACK_FIN:'/mapi/card_member/find_back_fin.htm',
  //会员卡证书下载
  API_DOWNLOAD_CERT:'/uapi/card_cert/download_cert.htm',
  //会员卡闪付接口
  API_QUICK_PASS:'/api/card/quick_pass.htm',
  //会员卡查询接口
  api_CARD_INFO:'/api/card/card_info.htm',
  //会员卡交易详情接口
  API_CARD_DETAIL:'/api/card/card_detail.htm',
  //申请会员卡接口
  API_CARD_APPLY:'/mapi/card_member/card_apply.htm',
  //获取申请会员卡验证短信码接口
  API_CARD_APPLY_SMS:'/mapi/card_member/card_apply_sms.htm',
  //会员卡自主充值编码接口
  API_CARD_OPTION_LIST:'/mapi/member/echarge/option_list.htm',
  //会员卡自主充值接口
  API_CARD_ECHARGE_ORDER:'/mapi/member/echarge/echarge_order.htm',
  //会员自主充值明细查看接口
  API_ECHARGE_VIEW:'/mapi/member/echarge/echarge_view.htm',
  //会员卡信息自主修改接口
  API_CARD_MODIFY:'/mapi/card_member/card_modify.htm',


  getMid() {
    let local_admin = JSON.parse(localStorage.getItem(this.AUTH_USER_KEY));
    if(local_admin) {
      return local_admin.ts;
    }
    return "";
  }
};



// WEBPACK FOOTER //
// ./src/lib/constants.js